import React from "react";
import { HeaderConfig } from "./types";
import { useRegDetail } from "shared/context/regDetail";
import { useDisplayBehaviour } from "apps/registration/components/displayBehaviour/displayBehaviourProvider";

function Header(props: HeaderConfig) {
  const { regPortalInfo, name: pageTitle, marketingUrl, logoUrl } = useRegDetail();

  React.useEffect(() => {
    window.document.title = pageTitle;
  }, [pageTitle]);

  return (
    <header className="regHeader">
      <div className="regHeader_logo">
        <a href={marketingUrl} target="_blank" rel="noopener noreferrer">
          <img src={logoUrl} alt="logo" />
        </a>
      </div>
      <div className="regHeader_details">
        {props.eventDetailsFlag && <span dangerouslySetInnerHTML={{ __html: regPortalInfo }} />}
      </div>
    </header>
  );
}

function HeaderWrapper(props: HeaderConfig) {
  const { behaviour } = useDisplayBehaviour();
  return behaviour.canShowRegistrationHeader() ? <Header {...props} /> : null;
}

export default HeaderWrapper;
